export const CONSTRUCTION_AUTODESK_URL = 'https://construction.autodesk.com';
export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired'
};
export const SUBSCRIPTION_TYPES = {
  TRIAL: 'trial',
  PAID: 'paid'
};
export const COLLABORATE_EXTERNAL_KEYS = {
  COLLABORATE: 'TRIAL-BIMCOLL',
  COLLABORATE_PRO: 'TRIAL-COLLRP'
};
export const EVENTS = {
  OPEN: 'licensing.trial_modal.open'
};
export const MAX_TRIAL_DAYS = 30;
//# sourceMappingURL=const.js.map